const MIN_REQUIRED_VIEWS = 100;
const STORAGE_ARTICLE_LIKE_HISTORY = 'client_like_history';
const shareDropdownContainerId = '#ueb-share-container';
const userEngagementToolbar = {
  views: {
    id: 'ueb-eye-container',
    content: 'VIEWS'
  },
  likes: {
    id: 'ueb-heart-container',
    content: 'LIKE'
  },
  audioPlay: {
    id: 'ueb-play-container',
    content: 'PLAY'
  },
  audioPause: {
    id: 'ueb-pause-container',
    content: 'PAUSE'
  },
  share: {
    id: 'ueb-share-container',
    content: 'SHARE'
  }
};

const template = `
<div id='ueb-share-options'>
  <section class="ueb-share-section">
    <button id='ueb-share-copy' data-share-button="true" class="ueb-share-button">
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 5.52208H5C2.92893 5.52208 1.25 7.20101 1.25 9.27208C1.25 11.3431 2.92893 13.0221 5 13.0221H8V11.5221H5C3.75736 11.5221 2.75 10.5147 2.75 9.27208C2.75 8.02944 3.75736 7.02208 5 7.02208H8V5.52208ZM11 11.5221V13.0221H14C16.0711 13.0221 17.75 11.3431 17.75 9.27208C17.75 7.20101 16.0711 5.52208 14 5.52208H11V7.02208H14C15.2426 7.02208 16.25 8.02944 16.25 9.27208C16.25 10.5147 15.2426 11.5221 14 11.5221H11ZM6.5 10.0221H12.5V8.52208H6.5V10.0221Z" fill="#88929E" />
        </svg>
        <span>Copy link</span>
    </button>

    <div class="ueb-share-social-divider"></div>

    <ul class="ueb-share-social-list">
        <li class="ueb-share-social-list__item">
            <button id='ueb-share-facebook' class="ueb-share-button">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.3929 1.77208H3.60714C3.1809 1.77208 2.77212 1.9414 2.47072 2.2428C2.16932 2.5442 2 2.95298 2 3.37922V15.1649C2 15.5912 2.16932 16 2.47072 16.3014C2.77212 16.6028 3.1809 16.7721 3.60714 16.7721H8.20257V11.6724H6.09319V9.27208H8.20257V7.44262C8.20257 5.3617 9.44141 4.21226 11.3388 4.21226C12.2475 4.21226 13.1978 4.37431 13.1978 4.37431V6.41672H12.1508C11.1192 6.41672 10.7974 7.0569 10.7974 7.71349V9.27208H13.1003L12.732 11.6724H10.7974V16.7721H15.3929C15.8191 16.7721 16.2279 16.6028 16.5293 16.3014C16.8307 16 17 15.5912 17 15.1649V3.37922C17 2.95298 16.8307 2.5442 16.5293 2.2428C16.2279 1.9414 15.8191 1.77208 15.3929 1.77208Z" fill="#88929E" />
                </svg>

                <span>post on facebook</span>
            </button>
        </li>
        <li class="ueb-share-social-list__item">
            <button id='ueb-share-x' class="ueb-share-button">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.14286 1.77208C2.96094 1.77208 2 2.73302 2 3.91494V14.6292C2 15.8111 2.96094 16.7721 4.14286 16.7721H14.8571C16.0391 16.7721 17 15.8111 17 14.6292V3.91494C17 2.73302 16.0391 1.77208 14.8571 1.77208H4.14286ZM14.0904 4.58458L10.615 8.55556L14.7031 13.9596H11.5022L8.99777 10.6817L6.12835 13.9596H4.53795L8.25446 9.7107L4.33371 4.58458H7.61495L9.8817 7.58123L12.5 4.58458H14.0904ZM12.8248 13.0087L7.13616 5.48525H6.18862L11.9408 13.0087H12.8214H12.8248Z" fill="#88929E" />
                </svg>

                <span>post on x</span>
            </button>
        </li>
        <li class="ueb-share-social-list__item">
            <button id='ueb-share-linkedin' class="ueb-share-button">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.04545 1.77208C2.91578 1.77208 2 2.68786 2 3.81753V14.7266C2 15.8563 2.91578 16.7721 4.04545 16.7721H14.9545C16.0842 16.7721 17 15.8563 17 14.7266V3.81753C17 2.68786 16.0842 1.77208 14.9545 1.77208H4.04545ZM4.31035 14.6292H6.53356H6.53691V7.47073H4.31035V14.6292ZM4.13289 5.20399C4.13289 5.91381 4.70879 6.49305 5.42195 6.49305C6.13512 6.49305 6.71102 5.91716 6.71102 5.20399C6.71102 4.49417 6.13178 3.91493 5.42195 3.91493C4.70879 3.91493 4.13289 4.49417 4.13289 5.20399ZM12.6441 14.6292H14.8673V10.7051C14.8673 8.77653 14.4487 7.29328 12.1987 7.29328C11.1173 7.29328 10.3907 7.88591 10.0927 8.44841H10.0626V7.47073H7.92977V14.6292H10.153V11.0868C10.153 10.1527 10.3304 9.24863 11.4889 9.24863C12.6273 9.24863 12.6441 10.3167 12.6441 11.1471V14.6292Z" fill="#88929E" />
                </svg>

                <span>post on linkedin</span>
            </button>
        </li>
    </ul>
  </section>
</div>
`;

(function ($) {
  function toggleLikeCounter(value) {
    const counterElement = $('.oacs-spl-counter');

    try {
      const counterText = counterElement.text().replaceAll(',', '');
      const counterValue = parseInt(counterText);
      const newCounterValue = counterValue + value;
      $(counterElement).text(newCounterValue);
    } catch (e) {
      console.error(e);
    }
  }

  function toggleLikeIcon(button) {
    $(button).toggleClass('oacs-spl-liked');
  }

  function toggleLikeCachedValue(postId, isLiked) {
    const likesHistoryStore = sessionStorage.getItem(STORAGE_ARTICLE_LIKE_HISTORY);
    const likesHistory = likesHistoryStore ? JSON.parse(likesHistoryStore) : {};
    
    likesHistory[postId] = !isLiked;
    sessionStorage.setItem(STORAGE_ARTICLE_LIKE_HISTORY, JSON.stringify(likesHistory));
  }

  function syncLikeStateFromStorage() {
    const likeButton = $('.oacs-spl-like-button');
    const postId = $('.ueb').data('post-id');

    const likesHistoryStore = sessionStorage.getItem(STORAGE_ARTICLE_LIKE_HISTORY);
    const likesHistory = likesHistoryStore ? JSON.parse(likesHistoryStore) : {};

    if (likesHistory[postId]) {
      likeButton.addClass('oacs-spl-liked');
    }
  }

  function toggleLike() {
    const likeButton = $('.oacs-spl-like-button');
    const isLiked = likeButton.hasClass('oacs-spl-liked');
    const postId = $('.ueb').data('post-id');

    toggleLikeCounter(isLiked ? -1 : 1);
    toggleLikeIcon(likeButton);
    toggleLikeCachedValue(postId, isLiked);
  }

  function fetchViewsAndLikes(cb) {
    const postId = $('.ueb').data('post-id');
    $.ajax({
      url: `/wp-json/workable2019/v1/get_user_engangement_info?post_id=${postId}`,
      dataType: 'json'
    })
      .done(function (response) {
        if (!response || !response.payload) return;

        const {payload} = response;
        const {views, likes, nonce} = payload;

        $('.post-views-count').text(views.toLocaleString('en-US'));

        $('.oacs-spl-counter').text(likes.toLocaleString('en-US'));

        const likeButton = document.querySelector('.oacs-spl-like-button');
        likeButton.dataset.nonce = nonce;

        cb();
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function useOptimisticLike() {
    $(document).on('click', '.oacs-spl-like-button', toggleLike);
  }

  function useViewMetrics() {
    const initialCount = $('.post-views-count').text();
    const viewsCounter = initialCount.replaceAll(',', '');

    try {
      const counterValue = Number(viewsCounter);

      if (counterValue >= MIN_REQUIRED_VIEWS) {
        $('#ueb-eye-container').removeClass('hide');
        $('#ueb-eye-container').addClass('show');
        $('.post-views-count').text(initialCount.toLocaleString('en-US'));
      }
    } catch (e) {
      console.error(e);
    }
  }

  function showTooltip(id, content) {
    tippy(`#${id}`, {
      content: content,
      placement: 'top',
      theme: 'material',
      arrow: true
    });
  }

  function copyToClipboard() {
    navigator.clipboard.writeText(window.location.href);

    const closeCopiedTooltipInterval = 1500;
    const tippyShareDropdownInstance = document.getElementById('ueb-share-container')._tippy;
    const tippyCopiedInfoInstance = document.getElementById('ueb-copied-anchor')._tippy;

    tippyShareDropdownInstance.hide();
    tippyCopiedInfoInstance.show();

    setTimeout(() => {
      tippyCopiedInfoInstance.hide();
    }, closeCopiedTooltipInterval);
  }

  function openShareWindow(social) {
    const newWindowProps = 'location=yes,height=570,width=520,scrollbars=yes,status=yes';
    const target = '_blank';
    const currentPage = window.location.href;
    const url = `https://www.addtoany.com/add_to/${social}?linkurl=${currentPage}`;

    window.open(url, target, newWindowProps);
  }

  function shareOnFacebook() {
    openShareWindow('facebook');
  }

  function shareOnX() {
    openShareWindow('x');
  }

  function shareOnLinkedIn() {
    openShareWindow('linkedin');
  }

  function attachDropdownListeners() {
    $(document).on('click', '#ueb-share-copy', copyToClipboard);
    $(document).on('click', '#ueb-share-facebook', shareOnFacebook);
    $(document).on('click', '#ueb-share-x', shareOnX);
    $(document).on('click', '#ueb-share-linkedin', shareOnLinkedIn);
  }

  function useDropdown() {
    tippy(shareDropdownContainerId, {
      content: template,
      theme: 'light',
      trigger: 'click',
      arrow: true,
      animation: 'scale',
      duration: [250, 200],
      distance: 12,
      interactive: true,
      showOnInit: true,
      allowHTML: true
    });
  }

  function hideViewsAndLikes() {
    $('.oacs-spl-counter').addClass('hide');
  }

  function showViewsAndLikes() {
    // $('.oacs-spl-counter').removeClass('hide');
    $('.post-views-count').removeClass('hide');
  }

  function useCopiedTooltip() {
    tippy('#ueb-copied-anchor', {
      content: 'Link Copied',
      theme: 'material',
      trigger: 'manual',
      delay: 250,
      arrow: false,
      allowHTML: true
    });
  }

  $(document).ready(function () {
    let uebExists = !!$('.ueb').length;

    // return if user-engagment-bar is not in the DOM
    if (!uebExists) {
      return;
    }

    // assign tooltips to items
    Object.keys(userEngagementToolbar).forEach(key => {
      let id = userEngagementToolbar[key].id;
      let content = userEngagementToolbar[key].content;

      showTooltip(id, content);
    });

    // enable sharing dropdown
    useDropdown();

    // hide view and like counter to avoid flickering
    // hideViewsAndLikes();

    // fetch views and likes to avoid caching issues
    fetchViewsAndLikes(() => {
      showViewsAndLikes();

      // sync like state for each article
      syncLikeStateFromStorage();

      // enable copy to clipboard success tooltip
      useViewMetrics();

      // use optimistic approach for likes
      useOptimisticLike();
    });

    // enable copy to clipboard success tooltip
    useCopiedTooltip();

    // attach social share listeners
    attachDropdownListeners();
  });
})(jQuery);
